class SimilarProduct extends HTMLElement {
  constructor () {
    super()
    this.variantChangeHandler = this.variantChangeHandler.bind(this)
    this.cta = this.querySelector('dialog-toggle button')
    this.cards = this.querySelectorAll('[data-sizes]')
    this.sizeLabel = this.querySelector('[data-target="size"]')
  }

  connectedCallback() {
    document.addEventListener("variant-change", this.variantChangeHandler)
  }

  variantChangeHandler (event) {
    const {options, available} = event.detail || {}
    const { Size: size } = options || {}
    this.cta.classList.add('hidden')

    if (!size || available) {
      return
    }

    this.sizeLabel.textContent = size
    let hasMatchingSize = false

    this.cards.forEach((item) => {
      const sizes = item.getAttribute("data-sizes")?.split(',')

      if (sizes && sizes.includes(String(size))) {
        item.classList.remove("hidden")
        hasMatchingSize = true
      } else {
        item.classList.add("hidden")
      }
    })

    if (hasMatchingSize) {
      this.cta.classList.remove('hidden')
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant-change", this.variantChangeHandler)
  }
}

customElements.define("similar-products", SimilarProduct)
